<div class="container" style="margin: 15px">
  <!-- Spinner -->
  @if (loading) {
    <div class="loading-spinner">
      <div class="spinner"></div>
      Generando PDF, por favor espera...
    </div>
  }

  <div class="grid w-full">
    <div #printpdf id="printpdf" style="width: w-full; height: w-full">
      <ng-container *ngFor="let qr of listQr">
        <div class="col-12">
          <div class="cuadro">
            <div class="text-center">
              <qrcode
                [qrdata]="qr.qrdata"
                [width]="qr.width"
                [errorCorrectionLevel]="'M'"></qrcode>
              <div class="flex align-items-center mb-10 pb-10">
                <img class="mr-3" [src]="qr.logo" width="55rem" />
                <strong class="flex justify-content-center pl-5">{{
                  qr.name
                }}</strong>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
